<template>
  <el-dialog
    id="popup_dialog"
    :title="titlu"
    :visible.sync="showPopup"
    class="my-dialog-class custom-width"

  >
    <div class="container">
      <el-form
        label-position="top"
        :inline="false"
        :rules="rules"
        label-width="100%"
        :model="selectedObject"
        ref="my-form"
        @submit.prevent="save"
        v-loading="loadingVisible"
      >
        <el-row :gutter="15">
          <el-col :md="8">
            <el-form-item label="Nume" prop="Nume">
              <el-input class="full-width" v-model="selectedObject.Nume" />
            </el-form-item>
          </el-col>          
          <el-col :md="8">
            <el-form-item label="Prenume" prop="Prenume">
              <el-input class="full-width" v-model="selectedObject.Prenume" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="Email" prop="Email">
              <el-input class="full-width" v-model="selectedObject.Email" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="Telefon" prop="Telefon">
              <el-input class="full-width" v-model="selectedObject.Telefon" />
            </el-form-item>
          </el-col> 
          <el-col :md="8">
            <el-form-item label="Firma" prop="IdFirmaFlota">
              <el-select class='full-width' v-model='selectedObject.IdFirmaFlota' filterable >
                <el-option v-for='item in Info.flote' :key="'flote' + item.Id" :label='item.Nume' :value='item.Id'></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="Observatii" prop="Observatii">
              <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="Observatii"
                  v-model="selectedObject.Observatii">
                  </el-input> 
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Manageri_flote_dialog",
  extends: BasePage,
  data() {
    let validateNumeric = async (rule, value, callback) => {
      if (value === undefined || value.length < 0 || value == null || this.selectedObject.Telefon.length <= 0) return callback('Campul este obligatoriu')
      this.selectedObject.Telefon = value.split("").filter(a => /^\d+$/.test(a)).join("");

    }
    return {
      baseUrl: "",
      showPopup: false,
      titlu: "",
      mode: "add",
      selectedObject: {
        Nume: "",
        Prenume: "",
        Email: "",
        Telefon: "",
        Observatii: "",
      },
      Info: {},
      rules: {
        Nume: [{ required: true, message: "Campul este obligatoriu" }],
        Prenume: [{ required: true, message: "Campul este obligatoriu" }],
        // Email: [{ required: true, message: "Campul este obligatoriu" }],
        Telefon:   [{ required: true, validator: validateNumeric }],
        IdFirmaFlota: [{ required: true, message: "Campul este obligatoriu" }],
      },
    };
  },
  methods: {
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.titlu = "Adauga";
        this.selectedObject = {};
      } else {
        this.mode = "edit";
        this.titlu = "Editeaza";
        var result = await this.post("admin/flote/get_info_item_dialog_manageri", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
    },
    async get_info() {
      var response = await this.post("admin/flote/get_info_for_dialog_manageri");
      this.Info.flote = response.flote;
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("admin/flote/save_manageri", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.$emit("save");
          this.selectedObject = {};
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">
#popup_dialog {
  .full-width {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }

  @media only screen and (max-width: 600px) {
    .el-dialog{
      min-width: 90vw !important;
    }
  }
}
</style>